// extracted by mini-css-extract-plugin
export default {"sm-separator":"sm-separator--IzVl0","smSeparator":"sm-separator--IzVl0","md-separator":"md-separator--EP78n","mdSeparator":"md-separator--EP78n"};